export default function tagSort() {
  const $submit = document.getElementById('js-tagSortSubmit');

  $submit.addEventListener(
    'click',
    element => {
      element.preventDefault();
      const form = document.tagSort;
      const formUrl = form.action;
      const params = [];
      let urls = '';
      const { themes } = form;
      const { areas } = form;
      const { seasons } = form;
      const { keywords } = form;
      const themesValues = [];
      const areasValues = [];
      const seasonsValues = [];
      if (themes) {
        const nodeThemes = Array.prototype.slice.call(themes, 0);
        if (nodeThemes.length) {
          nodeThemes.forEach(e => {
            if (e.checked) {
              themesValues.push(e.value);
            }
          });
        } else if (themes.checked) {
          themesValues.push(themes.value);
        }
        if (themesValues.length) {
          const themesString = themesValues.join(',');
          params.push(`themes=${themesString}`);
        }
      }
      if (areas) {
        const nodeAreas = Array.prototype.slice.call(areas, 0);
        if (nodeAreas.length) {
          nodeAreas.forEach(e => {
            if (e.checked) {
              areasValues.push(e.value);
            }
          });
        } else if (areas.checked) {
          areasValues.push(areas.value);
        }
        if (areasValues.length) {
          const areasString = areasValues.join(',');
          params.push(`areas=${areasString}`);
        }
      }
      if (seasons) {
        const nodeSeasons = Array.prototype.slice.call(seasons, 0);
        if (nodeSeasons.length) {
          nodeSeasons.forEach(e => {
            if (e.checked) {
              seasonsValues.push(e.value);
            }
          });
        } else if (seasons.checked) {
          seasonsValues.push(seasons.value);
        }
        if (seasonsValues.length) {
          const seasonsString = seasonsValues.join(',');
          params.push(`seasons=${seasonsString}`);
        }
      }
      if (keywords) {
        params.push(`keywords=${keywords.value}`);
      }
      params.forEach((param, index) => {
        if (index === 0) {
          urls += `?${param}`;
        } else {
          urls += `&${param}`;
        }
      });
      window.location.href = formUrl + urls;
    },
    true,
  );
}
